import { Edit, KeyboardArrowDown } from '@mui/icons-material';
import {
    Box,
    IconButton,
    InputBase,
    MenuItem,
    Select,
    Tooltip,
    useTheme,
} from '@mui/material';
import FlexBox from 'components/flexbox/FlexBox';
import { Small, Tiny } from 'components/Typography';
import { useMemo } from 'react'; // common cell component

const CommonCell = ({ title, body }) => (
    <FlexBox flexDirection="column">
        <Small mb={0.5}>{title}</Small>
        <Tiny color="text.secondary">{body}</Tiny>
    </FlexBox>
);

const columnShape = [
    {
        Header: 'Name',
        accessor: 'full_name',
    },
    {
        Header: 'Profession',
        accessor: 'profession.name',
    },
    {
        Header: 'Type',
        accessor: 'is_group',
        Cell: ({ value }) => {
            let type;
            value ? (type = 'Group') : (type = 'Individual');
            return <>{type}</>;
        },
    },
    {
        Header: 'Phone',
        accessor: 'phone_number',
    },
    {
        Header: 'Email',
        accessor: 'email',
    },
    {
        Header: 'Institution',
        accessor: 'institution',
    },
    {
        Header: 'City',
        accessor: 'city',
    },
];
export function SelectColumnFilter({ column }) {
    const { filterValue, setFilter, preFilteredRows, id } = column;
    const theme = useTheme();
    const options = useMemo(() => {
        const options = new Set();
        preFilteredRows.forEach((row) => options.add(row.values[id]));
        return [...options.values()];
    }, [id, preFilteredRows]); // Render a multi-select box

    return (
        <Select
            value={filterValue || ''}
            onChange={(e) => setFilter(e.target.value || undefined)}
            IconComponent={() => <KeyboardArrowDown color="disabled" />}
            input={
                <InputBase
                    sx={{
                        height: 40,
                        width: 110,
                        fontSize: 12,
                        fontWeight: 600,
                        padding: '0 8px',
                        borderRadius: '8px',
                        color: 'text.primary',
                        backgroundColor:
                            theme.palette.mode === 'light'
                                ? '#ECEFF5'
                                : 'divider',
                        '& .MuiPopover-paper': {
                            boxShadow: 'none',
                        },
                        '& > .MuiSelect-select': {
                            paddingRight: '0 !important',
                        },
                    }}
                />
            }
        >
            <MenuItem
                value=""
                sx={{
                    fontSize: 12,
                    fontWeight: 500,
                }}
            >
                All
            </MenuItem>
            {options.map((option, i) => (
                <MenuItem
                    key={i}
                    value={option}
                    sx={{
                        fontSize: 12,
                        fontWeight: 500,
                    }}
                >
                    {option}
                </MenuItem>
            ))}
        </Select>
    );
}
// export function DateColumnFilter({
//   column
// }) {
//   const {
//     filterValue,
//     setFilter
//   } = column;
//   const theme = useTheme();

//   const handleChange = newValue => {
//     const date = format(new Date(newValue), "MMM dd, yyyy") || undefined;
//     setFilter(date);
//   };

//   return <DatePicker value={filterValue || ""} onChange={handleChange} renderInput={params => {
//     return <TextField {...params} disabled error={false} inputProps={{
//       placeholder: ""
//     }} sx={{
//       "& .MuiOutlinedInput-root": {
//         height: 40,
//         borderRadius: "8px",
//         backgroundColor: theme.palette.mode === "light" ? "#ECEFF5" : "divider" // width: 80,

//       },
//       "& .MuiOutlinedInput-notchedOutline": {
//         border: "none"
//       },
//       "& .MuiOutlinedInput-input": {
//         padding: 0,
//         paddingLeft: 1
//       },
//       "& .MuiSvgIcon-root": {
//         fontSize: 22,
//         color: "text.secondary"
//       }
//     }} />;
//   }} />;
// }
export default columnShape;
